import { defineComponent as _defineComponent } from 'vue'

import { computed, PropOptions } from 'vue';
import { defaultCurrencyFormatter } from '../helpers/currency';

export const formattedNumberProps = {
  value: { type: [Number, String] },
  prefixLabel: { type: String, default: '' },
  formatter: {
    type: Intl.NumberFormat,
    default: () => defaultCurrencyFormatter,
  },
  scaledDecimals: {
    type: [Boolean, String],
    default: false,
  },
  placeholder: {
    type: String,
    default: '-',
  },
} satisfies Record<string, PropOptions>;

export default /*#__PURE__*/_defineComponent({
  __name: 'FormattedNumber',
  props: formattedNumberProps,
  setup(__props) {

const props = __props;



const valueParts = computed<Intl.NumberFormatPart[]>(() =>
  typeof props.value === 'number'
    ? props.formatter.formatToParts(props.value)
    : [
        {
          value: props.placeholder,
          type: 'nan',
        },
      ]
);

return { __sfc: true,formattedNumberProps, props, valueParts }
}

})